import { Component, OnInit } from '@angular/core';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import { DateService } from '../../common/date.service';

import { TouristGuidesRewardFiltersComponent } from './tourist-guides-reward-filters/tourist-guides-reward-filters.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-tourist-guides-reward',
	templateUrl: './tourist-guides-reward.component.html',
	styleUrls: ['./tourist-guides-reward.component.css'],
})
export class TouristGuidesRewardComponent implements OnInit {
	private itemsBeforeDataLoad = 4;
	loader = true;
	data: Array<any>;
	vehicle: Array<any>;
	touristGuides: Array<any>;
	currencies: Array<any> = [];
	date_from: string;
	date_to: string;
	sortKey: string;
	private sortAscending = false;
	employment = [
		{ id: '0', name: '(Brak)' },
		{ id: '1', name: 'Umowa' },
		{ id: '2', name: 'Fv' },
	];
	paymentMethods = [
		{ id: '0', name: '(Brak)' },
		{ id: '1', name: 'Przelew' },
		{ id: '2', name: 'Gotówka' },
	];
	private readonly types = [
		{ id: 'return', name: 'Powrót' },
		{ id: 'program', name: 'Program' },
		{ id: 'departure', name: 'Odprowadzenie' },
	];
	tableRows = [
		{ id: 'name', name: 'Wydarzenie' },
		{ id: 'vehicle_name', name: 'Pojazd' },
		{ id: 'date_from', name: 'Data od' },
		{ id: 'date_to', name: 'Data do' },
	];
	filters = {
		search: null,
		date_from: null,
		date_to: null,
		touristGuide: [],
		calculated: [],
	};
	parameters = {
		touristGuide: [],
		calculated: [],
	};

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly infobox: InfoboxService,
		private readonly route: ActivatedRoute,
		protected router: Router,
	) {}

	ngOnInit(): void {
		this.api.get('/currency', (result, error) => {
			this.currencies = result.data;
		});
		this.api.get('/parameters/', (result, error) => {
			this.parameters.calculated = [
				{ id: 0, name: 'Nie' },
				{ id: 1, name: 'Tak' },
			];
			this.loadData();
		});
		this.api.get('/touristGuides/', (result, error) => {
			this.touristGuides = result.data;
			this.loadData();
		});
		this.api.get('/vehicles/', (result, error) => {
			this.vehicle = result.data;
			this.loadData();
		});
	}

	loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		const parms: string = this.api.getChecked(this.filters, this.parameters);
		this.loader = true;
		this.api.get('/touristGuidesReward/?' + parms, (result, error) => {
			result.data.forEach((obj) => {
				const type = this.types.find((objfind) => objfind.id == obj.type);
				obj.typeName = type ? type.name : '?';
				const vehicle = this.vehicle.find((objfind) => objfind.id == obj.vehicle);
				obj.vehicle_name = vehicle ? vehicle.name : '?';
				const touristGuides = this.touristGuides.find((objFind) => objFind.id == obj.touristGuide);
				obj.tourist_guide = touristGuides ? touristGuides.name : '?';
				obj.calculated = obj.calculated == '1' ? 1 : 0;
				obj.verified = obj.verified == '1' ? 1 : 0;
				obj.payment = obj.payment == '1' ? 1 : 0;
				obj.salary_comments = touristGuides ? touristGuides.salaryComments : '';
			});
			this.data = result.data;
			this.loader = false;
		});
	}

	verified(item) {
		item.verified = !item.verified;
		this.api.command(
			'/touristGuidesReward/' + item.id + '/',
			{ cmd: 'verify', set: item.verified },
			(result, error) => {
				if (error) {
					item.verified = !item.verified;
					return;
				}
			},
		);
	}

	payment(item) {
		item.payment = !item.payment;
		this.api.command(
			'/touristGuidesReward/' + item.id + '/',
			{ cmd: 'payment', set: item.payment },
			(result, error) => {
				if (error) {
					item.payment = !item.payment;
					return;
				}
			},
		);
	}

	calculated(item) {
		item.calculated = !item.calculated;
		this.api.command(
			'/touristGuidesReward/' + item.id + '/',
			{ cmd: 'calculate', set: item.calculated },
			(result, error) => {
				if (error) {
					item.calculated = !item.calculated;
					return;
				}
			},
		);
	}

	save(data) {
		data.editable = false;
		this.loader = true;
		if (data.id) {
			this.objectEdit(data);
			return;
		}
	}

	private objectEdit(data) {
		data.calculated = data.calculated ? 1 : 0;
		data.verified = data.verified ? 1 : 0;
		data.payment = data.payment ? 1 : 0;
		this.api.put('/touristGuidesReward/' + data.id + '/', data, (result, error) => {
			this.loader = false;
			if (error) {
				return;
			}
		});
	}

	filtersOpen() {
		new TouristGuidesRewardFiltersComponent(this.api, this.route, this.router).filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		if (!this.filters.date_from) {
			this.filters.date_from = this.date.daysAdd(-5);
		}
		if (!this.filters.date_to) {
			this.filters.date_to = this.date.daysAdd(+5);
		}
		this.loadData();
	}

	setSort(key) {
		this.sortKey = key;
		this.sortAscending = !this.sortAscending;
		this.sortSave();
		this.sortSort();
	}

	private sortSort() {
		if (this.sortAscending) {
			this.data = this.data.sort((a, b) => a[this.sortKey]?.localeCompare(b[this.sortKey]));
		} else {
			this.data = this.data.sort((a, b) => b[this.sortKey]?.localeCompare(a[this.sortKey]));
		}
	}
	private sortSave() {
		localStorage.setItem('touristGuidesEvents-sortKey', JSON.stringify(this.sortKey));
		localStorage.setItem('touristGuidesEvents-sortAscending', JSON.stringify(this.sortAscending));
	}

	private sortLoad() {
		if (localStorage['touristGuidesEvents-sortKey']) {
			this.sortKey = JSON.parse(localStorage['touristGuidesEvents-sortKey']);
		}
		if (localStorage['touristGuidesEvents-sortAscending']) {
			this.sortAscending = JSON.parse(localStorage['touristGuidesEvents-sortAscending']);
		}
		this.sortSort();
	}
	/*public salaryChanged() {
    if (this.data.tax && this.data.salary) {
      return;
    }
    this.data.tax = this.data.salary;
  }*/
}
